import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AwrDomainContext, AwrAccountContextValue } from '../model/AwrContext';
import { IStorageService } from '@pershing/pershing-core';

@Injectable()
export class AWRContextService {
    selectedAwrDomainContext$: Observable<AwrDomainContext<any>>;
    selectedOrgContext$: Observable<any>;
    error$: Observable<any>;
    _error: BehaviorSubject<any>;
    defaultContext: AwrDomainContext<any> = {
        domain: null,
        value: null
    };
    hasError: boolean;
    private gotoParam: any;
    _selectedDomainBehavior: BehaviorSubject<AwrDomainContext<any>>;
    private dataStore: {
        selectedAwrDomainContext: AwrDomainContext<any>;
    };
    constructor(private storageService: IStorageService) {
        this._selectedDomainBehavior = new BehaviorSubject<any>('');
        this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        this._error = new BehaviorSubject<any>('');
        this.error$ = this._error.asObservable();
        console.log('in context constructor');
        this.loadLocalStorage();
    }
    setAwrDomainContext(domain: string, value: any): void {
        console.log('value in setAwrDomainContext===========' + value);
        localStorage.setItem('awrDataContext', JSON.stringify(value)) ;
        this.dataStore.selectedAwrDomainContext = value;
        this._selectedDomainBehavior.next(value);
    };
    setGotoContext(goToContext: any) {
        this.gotoParam = goToContext;
    }
    getGotoContext() {
        return this.gotoParam;
    }
    setOrgAwrDomainContext(domain: string, value: any): void { };
    clearContextError(): any { };
    getDeviceType(): any { };
    clearContext(): void { };
    loadLocalStorage(): void {

        // fetching dataStore from LocalStorage.
        this.dataStore = {
            selectedAwrDomainContext: null
        };
        // Emits the default context domain -- account
        this._selectedDomainBehavior = new BehaviorSubject<AwrDomainContext<any>>(this.defaultContext);
        this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        // console.log('localStoRAGE' + localStorage);
        // if (localStorageValue !== null && localStorageValue !== undefined) {
        //     this.storageService.removeItem('awrDataStore');
        //     this.dataStore = (JSON.parse(localStorageValue));
        //     // Emits the context domain from localStorage
        //     if (this.dataStore.selectedAwrDomainContext && this.dataStore.selectedAwrDomainContext !== null) {
        //         this._selectedDomainBehavior = new BehaviorSubject(this.dataStore.selectedAwrDomainContext);
        //         this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        //         let AwrDomainContext: any = this.dataStore.selectedAwrDomainContext.domain;
        //         // if (AwrDomainContext === 'account') {
        //         let accountContextValue: any = this.dataStore.selectedAwrDomainContext;
        //         let domainValue: AwrAccountContextValue = new AwrAccountContextValue(accountContextValue.accountNumber, accountContextValue.timeperiod,
        //             accountContextValue.goToTab, accountContextValue.awrAccount);
        //         this.setAwrDomainContext(AwrDomainContext, this.createAwrDomainContext(AwrDomainContext, domainValue));
        //         this.storageService.setItem('awrDataStore', JSON.stringify(this.dataStore));
        //         // } else {
        //         //     this.dataStore.selectedAwrDomainContext = null;
        //         //     this._selectedDomainBehavior = new BehaviorSubject<AwrDomainContext<any>>(this.defaultContext);
        //         //     this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        //         // }
        //     } else {
        //         this.dataStore.selectedAwrDomainContext = null;
        //         this._selectedDomainBehavior = new BehaviorSubject<AwrDomainContext<any>>(this.defaultContext);
        //         this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        //     }
        // } else {
        //     this.dataStore = {
        //         selectedAwrDomainContext: null
        //     };
        //     // Emits the default context domain -- account
        //     this._selectedDomainBehavior = new BehaviorSubject<AwrDomainContext<any>>(this.defaultContext);
        //     this.selectedAwrDomainContext$ = this._selectedDomainBehavior.asObservable();
        // }
    }
    createAccountContext(value: any): AwrDomainContext<AwrAccountContextValue> {
        return value ;
    }
    createAwrDomainContext(domain: string, value: any): AwrDomainContext<any> {
        let AwrDomainContext: AwrDomainContext<any>;
        AwrDomainContext = this.createAccountContext(value);
        localStorage['awrdataStore'] = JSON.stringify(AwrDomainContext);
        return AwrDomainContext;
    }
    saveLocalStorage(): void {
        if (this.dataStore && this.dataStore.selectedAwrDomainContext) {
            if (this.dataStore && this.dataStore.selectedAwrDomainContext) {
                this.storageService.setItem('awrDataStore', JSON.stringify(this.dataStore));
            }
        }
    };
    isAuthenticated(): boolean { return true; };
    setContextError(errorMessage: string, errorCode?: string): any { };
    setDeviceType(deviceType: string): any { };
}
